import React, { useState, useEffect, useCallback } from 'react';
import { getBoundCreditCards, deleteCreditCard, setDefaultCreditCard } from '../services/api';

const ManageCardsPage = () => {
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const fetchCards = useCallback(async () => {
        try {
            setLoading(true);
            setError('');
            const response = await getBoundCreditCards();
            setCards(response.data.data || []);
        } catch (err) {
            setError('無法獲取信用卡列表，請稍後再試。');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCards();
    }, [fetchCards]);

    // 【修改處】調整 handleDelete 的邏輯
    const handleDelete = async (cardId) => {
        if (submitting) return;
        if (!window.confirm('您確定要刪除這張信用卡嗎？')) return;
        
        setSubmitting(true);
        try {
            await deleteCreditCard(cardId);
            alert('信用卡已成功刪除！');
            
            // 【關鍵修改】直接更新前端的 state，而不是重新 fetch 整個列表
            // setCards 會接收一個函式，其參數是“當前的” cards 狀態
            // 我們回傳一個過濾掉被刪除卡片的新陣列，React 會自動更新畫面
            setCards(currentCards => currentCards.filter(card => card.cardId !== cardId));

        } catch (err) {
            alert(`刪除失敗：${err.response?.data?.message || '發生未知錯誤'}`);
        } finally {
            setSubmitting(false);
        }
    };

    const handleSetDefault = async (cardId) => {
        if (submitting) return;
        setSubmitting(true);
        try {
            await setDefaultCreditCard(cardId);
            alert('已成功設定為預設信用卡！');
            await fetchCards(); // 設定預設卡後，需要重新 fetch 來更新所有卡的 isDefault 狀態
        } catch (err) {
            alert(`設定失敗：${err.response?.data?.message || '發生未知錯誤'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>管理您的信用卡</h2>
                <button onClick={fetchCards} disabled={loading} className="refresh-button">
                    {loading ? '刷新中...' : '重新整理'}
                </button>
            </div>
            
            {error && <p className="error-message">{error}</p>}
            
            {!loading && cards.length === 0 && !error && <p>您目前沒有綁定任何信用卡。完成 3D 驗證後請點擊「重新整理」按鈕查看。</p>}
            
            <div className="cards-list-container">
                {cards.map(card => (
                    <div key={card.cardId} className="card-item">
                        <div className="card-info">
                            <span className="card-brand">VISA</span>
                            <span className="card-number">**** **** **** {card.card4No}</span>
                            <span className="card-expiry">有效期限: {card.cardValidMM}/{card.cardValidYY}</span>
                            {card.isDefault && <span className="default-badge">預設</span>}
                        </div>
                        <div className="card-actions">
                            {!card.isDefault && (
                                <button onClick={() => handleSetDefault(card.cardId)} disabled={submitting} className="action-button default">設為預設</button>
                            )}
                            <button onClick={() => handleDelete(card.cardId)} disabled={submitting} className="action-button delete">刪除</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageCardsPage;